<div class="modal-dialog modal-dialog-centered modal-md">
  <div class="modal-content">
    <div class="modal-header pb-2">
      <h5 class="modal-title" i18n>Editar permissões de acesso</h5>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="modal-body">
      <div class="row no-gutters align-items-center mb-4">
        <div class="col-md-2">
          <app-avatar
            [user]="initialState?.user"
            class="avatar-userGroup-list"></app-avatar>
        </div>
        <div class="col-md-10">
          <p class="mb-0 mt-2">
            <strong>{{ initialState?.user?.name }}</strong>
          </p>
          <p class="mb-0">{{ initialState?.user?.email }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card mb-2 bg-gray--100"
            *ngFor="let permissionItem of permissionItems">
            <div class="card-body">
              <div
                class="btn-expand d-flex justify-content-between align-items-center"
                (click)="openOrClone(permissionItem)">
                {{ permissionItem?.itemName }}
                <div class="expand">
                  <i class="material-icons"
                    *ngIf="!permissionItem?.isOpen">expand_more</i>
                  <i class="material-icons"
                    *ngIf="permissionItem?.isOpen">expand_less</i>
                </div>
              </div>
              <div class="expand-content mt-2" *ngIf="permissionItem?.isOpen">
                <p *ngFor="let permItem of permissionItem?.permissions">
                  <!--
                  ECS-5404
                  Remover *ngIf após implementação de deleção de contrato e aferição
                  *ngIf="permItem?.name !== 'DeleteContract' && permItem?.name !== 'DeleteAppraisal'"
                  -->
                  <mat-checkbox i18n
                    *ngIf="permItem?.name !== 'DeleteContract' && permItem?.name !== 'DeleteAppraisal'"
                    color="primary"
                    (click)="changePermission(permissionItem, permItem)"
                    [checked]="permItem?.checked">
                    {{ permissionI18n[permItem?.name] }}
                  </mat-checkbox>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-page" *ngIf="loading">
      <div class="loading-spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>

    <div class="modal-footer justify-content-end" *ngIf="!loading">
      <div>
        <button (click)="onCancel()" class="btn btn-outline-secondary mr-2">
          <app-loading
            [promise]="promise"
            text="Cancelar"
            i18n-text>
          </app-loading>
        </button>

        <button (click)="onAllSubmited()" class="btn btn-primary">
          <app-loading
            [promise]="promise"
            text="Confirmar"
            i18n-text>
          </app-loading>
        </button>
      </div>
    </div>
  </div>
</div>
